import { useIntl } from 'react-intl'

export function useTranslate() {
  const { formatMessage } = useIntl()
  return formatMessage
}
